import { getPositionUpdateForDragDelta } from "@skilitics/drag-drop";

import { useEventSubscribe } from "../../events/index.ts";
import { canvasEventTypes, type DndPositionUpdateEventOptions } from "../dnd/index.ts";
import { useEditingCss } from "./EditingCssPropertiesContext.ts";

type Props = {
  nodeId: number;
};

/**
 * Subscribes to position update events from canvas dragging and updates
 * the node's CSS inset properties based on the active offset origin.
 *
 * Uses browser-computed inset values from the drag event as the base position,
 * so non-px units (%, em) are cleanly resolved to pixels on drag.
 */
export const PositionUpdateSubscriber = ({ nodeId }: Props) => {
  const { layoutSettings, onCssPropertiesChange } = useEditingCss();

  useEventSubscribe(
    canvasEventTypes.UPDATE_CANVAS_NODE_POSITION,
    ({ nodeId: eventNodeId, delta, computedInset, scale }: DndPositionUpdateEventOptions) => {
      if (eventNodeId !== nodeId) return;

      const update = getPositionUpdateForDragDelta({
        offsetOrigin: layoutSettings.offsetOrigin,
        delta,
        scale,
        computedInset,
      });
      onCssPropertiesChange(update);
    },
  );

  return null;
};
